import { localeCompareBy } from "@/components/ui/Picker";
import { useMemo } from "react";

import { UserPickerBadgesView } from "./UserPickerBadgesView";
import type { UserOption, UserPickerMultiSelectProps } from "./types";
import { StopClickPropagation, runOrToast } from "./utils";

const excludeAssigned = (users: UserOption[], assigned: UserOption[]): UserOption[] => {
  const assignedIds = new Set(assigned.map((user) => user.user_id));
  return users.filter((user) => !assignedIds.has(user.user_id));
};

const byName = localeCompareBy<UserOption>((user) => user.name);

export const UserPickerMultiSelect = ({
  users,
  value,
  variant,
  onAdd,
  onRemove,
  addLabel,
  searchPlaceholder,
  emptyText,
  isEditable = true,
  isLoading = false,
}: UserPickerMultiSelectProps) => {
  const candidates = useMemo(() => excludeAssigned(users, value), [users, value]);
  const sortedAssigned = useMemo(() => [...value].sort(byName), [value]);

  return (
    <StopClickPropagation>
      <UserPickerBadgesView
        candidates={candidates}
        assigned={sortedAssigned}
        variant={variant}
        addLabel={addLabel}
        searchPlaceholder={searchPlaceholder}
        emptyText={emptyText}
        isEditable={isEditable}
        isLoading={isLoading}
        onAdd={(userId) => runOrToast(() => onAdd(userId))}
        onRemove={(userId) => runOrToast(() => onRemove(userId))}
      />
    </StopClickPropagation>
  );
};
